import React from "react";
import { withRouter } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import ContentLoader from "react-content-loader";
import CreateUser from "./CreateUser";
import EditUser from "./EditUser";
import EditAdmin from "./EditAdmin";
import Button from "./utilities/Button";

class Admin extends React.Component {
  constructor(props) {
    super();

    this.state = {
      refetch: false,
      confirm: false
    };
  }
  isLoggedIn = () => {
    return (
      this.props.loggedInUserQuery.loggedInUser &&
      this.props.loggedInUserQuery.loggedInUser.id !== null
    );
  };
  setRefetch = refetchBool => {
    this.setState({ refetch: refetchBool });
  };
  render() {
    if (this.props.loggedInUserQuery.loading) {
      return (
        <section className="hero is-fullheight is-vcentered">
          <div className="hero-body">
            <div className="container">
              <div className="columns  is-centered">
                <div className="column is-4 has-text-centered">
                  <ContentLoader type="facebook" />
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }

    if (!this.isLoggedIn()) {
      console.warn("not logged in");
      this.props.history.replace("/login");
    }
    if (this.props.loggedInUserQuery.loggedInUser.role !== "ADMIN") {
      this.props.history.replace("/");
    }

    return (
      <div className="container">
        <div className="columns  is-centered">
          <div className="column is-4">
            <h1 className="has-text-centered is-size-3">Administration</h1>
          </div>
        </div>
        <div className="columns  is-centered">
          <div className="column is-10 has-text-centered">
            <Button
              text="Déconnecter"
              type="button"
              onClick={() => {
                localStorage.removeItem("graphcoolToken");
                window.location.reload();
              }}
            />
          </div>
        </div>
        <div className="columns  is-centered">
          <CreateUser setRefetch={this.setRefetch} />
          <EditUser setRefetch={this.setRefetch} refetch={this.state.refetch} />
          <EditAdmin adminId={this.props.loggedInUserQuery.loggedInUser.id} />
        </div>
      </div>
    );
  }
}

const LOGGED_IN_USER_QUERY = gql`
  query LoggedInUserQuery {
    loggedInUser {
      id
      role
      email
      name
    }
  }
`;
export default compose(
  graphql(LOGGED_IN_USER_QUERY, {
    name: "loggedInUserQuery",
    options: { fetchPolicy: "network-only" }
  }),
  withRouter
)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js